package team.platforma.dictionarydata.database.dictionarydata

import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.AfterVersion
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import kotlin.Long
import kotlin.Unit
import kotlin.reflect.KClass
import team.platforma.dictionarydata.database.DictionaryDatabase
import team.platforma.dictionarydata.table.AiChapterQueries
import team.platforma.dictionarydata.table.AiModelQueries

internal val KClass<DictionaryDatabase>.schema: SqlSchema<QueryResult.AsyncValue<Unit>>
  get() = DictionaryDatabaseImpl.Schema

internal fun KClass<DictionaryDatabase>.newInstance(driver: SqlDriver): DictionaryDatabase =
    DictionaryDatabaseImpl(driver)

private class DictionaryDatabaseImpl(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver),
    DictionaryDatabase {
  override val aiChapterQueries: AiChapterQueries = AiChapterQueries(driver)

  override val aiModelQueries: AiModelQueries = AiModelQueries(driver)

  public object Schema : SqlSchema<QueryResult.AsyncValue<Unit>> {
    override val version: Long
      get() = 1

    override fun create(driver: SqlDriver): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
      driver.execute(null, """
          |CREATE TABLE AiChapter (
          |  id INTEGER NOT NULL PRIMARY KEY,
          |  name TEXT NOT NULL
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE AiModel (
          |    id INTEGER NOT NULL PRIMARY KEY,
          |    name TEXT NOT NULL,
          |    chapter INTEGER NOT NULL,
          |    description TEXT NOT NULL,
          |    cover TEXT
          |)
          """.trimMargin(), 0).await()
    }

    override fun migrate(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
      vararg callbacks: AfterVersion,
    ): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
    }
  }
}
